function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  stroke: "#bf0000",
  id: "svg_2",
  height: 600,
  width: 600,
  y: 0,
  x: 0,
  strokeWidth: 70,
  fill: "none"
}));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 600 600"
}, props), _ref);

export default __webpack_public_path__ + "static/media/emptyTile.876f568e.svg";
export { SvgComponent as ReactComponent };